import Api from './Api';

function getBaseURL()
{
    return process.env.ORDER_HISTORY_API_ENDPOINT + "&orderBy=CreateDate&sortOrder=desc";
}

function getReckonBaseURL()
{
    return process.env.MYOB_HISTORY_API_ENDPOINT + "&orderBy=Date&sortOrder=desc";
}

export default {
    GetOrderHistory(skip, take) {
        var url = getBaseURL() + "&skip=" + skip + "&take=" + take;
        return Api.get(url);
    },
    GetOrder(key) {
        var url = process.env.ORDER_HISTORY_API_ENDPOINT + "&key=" + key;
        return Api.get(url);
    },
    GetReckonInvoice(key) {
        var url = process.env.MYOB_HISTORY_API_ENDPOINT + "&key=" + key;
        return Api.get(url);
    },
    GetReckonInvoices(skip, take) {
        var url = getReckonBaseURL() + "&skip=" + skip + "&take=" + take;
        return Api.get(url);
    },
}


// WEBPACK FOOTER //
// ./src/services/OrderHistoryService.js